export default {
    inserted: el => {
      function loadImage() {
          // console.log('loadImage')
        const imageElement = Array.from(el.children).find(
          el => el.nodeName === "IMG"
        );

        // console.log('el.children:')
        // console.log(el.children)
        // console.log('el')
        // console.log(el.children)
  
        if (imageElement) {
          imageElement.decoding = "async";
          imageElement.addEventListener("load", () => {
            if (imageElement.decode) {
              imageElement.decode().catch(() => {}).then(() => {
                el.classList.add("loaded");
              });
            } else {
              el.classList.add("loaded");
            }
          });
          imageElement.addEventListener("error", () => {
            el.classList.add("image-error");
          });

          if (imageElement.dataset.url) {
            imageElement.src = imageElement.dataset.url;
          } else {
            el.classList.add("image-error");
          }
        }
      }
  
      function handleIntersect(entries, observer) {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            return;
          } else {
            loadImage();
            observer.unobserve(el);
          }
        });
      }
  
      function createObserver() {
        const options = {
          // circumstances under which the observer's callback is invoked
          root: null, // defaults to the browser viewport if not specified or if null
          rootMargin: "180px 0px",
          threshold: "0.01" // start shortly before the image enters the viewport
          // threshold of 1.0 means that when 100% of the target is visible within
          //the element specified by the root option, the callback is invoked
        };
  
        // Whether you're using the viewport or some other element as the root,the API works the same way,
        // executing a callback function you provide whenever the visibility of the target element changes
        // so that it crosses desired amounts of intersection with the root
  
        const observer = new IntersectionObserver(handleIntersect, options);
  
        observer.observe(el); // target element to watch
      }
  
      if (!window["IntersectionObserver"]) {
        loadImage();
      } else {
        createObserver();
      }
    }
  };